
export const TACSPACE = "TAC";
export const AUTOMATIONSPACE = "";
export const RESOLUTIONCODEURL = "/api/incident/getresolutioncode/";
export const PREPAREURL = "/api/prepare";
export const LOGOUTURL = "/api/logout";
export const KNOWLEDGEARTICLESURL = "/api/incident/getincidentdetails/";
export const DOWNLOADKNOWLEDGEARTICLEURL = "/api/incident/getqsgdocument";
export const IMPACTDATAURL = "/api/alerts/impactdata/";
export const DEPENDENCEYFAILUREIMPACTURL =  "/api/alerts/getDependencyFailureImpact/";
export const SAPFAILUREIMPACTURL =  "/api/alerts/getSAPFailureImpact/";
export const GETINCIDENTACTIVITYURL = "/api/incident/getincidentactivity/";
export const UPDATEINCIDENTURL = "/api/incident/updateIncidentDetails";
export const DEPENDENCYROOTCAUSESURL = "/api/alerts/getDependencyRootCasues";
export const AUTOMATAEXCEPTIONLOGSURL = "/api/alerts/getAutomataExceptionLogs";
export const GETALERTSURL = "/api/alerts/getAlerts";
export const GETSAPALERTSURL = "/api/alerts/getSAPAlerts";
export const GETPREDECTIVEALERTSURL ="/api/alerts/getPredictedAlerts";
export const GETCLIENTSURL = "/api/alerts/getClients";
export const GETALERTSFILTERDATAURL = "/api/alerts/getAlertsFilterData";
export const GETPREDECTIVEALERTSFILTERDATAURL = "/api/alerts/getPredictedAlertsFilterData";
export const GETUSERPREFRENCESURL = "/api/alerts/getUserPreferences";
export const UPDATEUSERPREFRENCESURL = "/api/alerts/updateUserPreferences";
export const GETINCIDENTDETAILSURL = "/api/incident/getincidentdetails/";
export const GETINCIDENTDETAILSRCAURL = "/api/incident/getincidentdetailsRCA/";
export const GETASSIGNEDTO = '/api/incident/getassignedto';
export const GETASSIGNMENTGROUP = '/api/incident/getassignmentgroup/';
export const GETALLCATEGORYURL = "/api/incident/getallcategory";
export const GETALLSUBCATEGORYURL ="/api/incident/getallsubcategory";
export const UPLOADATTACHMENT = "/api/incident/uploadAttachment/";
export const GETALLATTACHMENT ="/api/incident/getattachment";
export const POSTCOLLABORATIONURL ="/api/collaboration/postToCollaboration/";
export const PROCESSPAYLOAD ="/api/collaboration/processPayload/";
export const ROOTCAUSEANALYSIS ="/api/alerts/getRootCauseAnalysis/";
export const DOWNLOADSERVICENOWATTACHMENT = "/api/incident/downloadservicenowattachment";
export const QUESTIONANSWERSURL = "/api/incident/questionanswers"
export const CODEQUALITYCHECKUPLOADFILE ="/api/operationsmanagement/uploadfile/";
export const CODEQUALITYCHECKCLIENT ="/api/operationsmanagement/client/";
export const CODEQUALITYCHECKTECHNOLOGY ="/api/operationsmanagement/technology/";
export const CODEQUALITYCHECKFRANCHISE ="/api/operationsmanagement/franchise/";
export const POSTSCHEDULESUBMIT = "/api/page2/page2/"
export const POSTUNIQUEAUTOMATA = "/api/page2/uniqueautomatanames";
export const POSTAPPLICATIONHOST = "/api/page2/uniqueapphost";
export const POSTAPPSTACK = "/api/getappstack";
export const POSTAPPSTACKFORAPPS = "/api/getappstackforapps";
export const RECOMMENDRESOURCE = "/api/recommendation/calendar-recommendation";
export const CODEQUALITYCHECKFILESUBMISSIONLIST = "/api/operationsmanagement/filesubmissionlist";
export const CODEQUALITYCHECKRESULT = "/api/operationsmanagement/result/";
export const GETSAPALERTSFILTERDATAURL = "/api/alerts/getSAPAlertsFilterData";
export const GETPREDECTIVESAPALERTSFILTERDATAURL = "/api/alerts/getPredictedSAPAlertsFilterData";
export const GETUSERTASKFORINCIDENT = "/api/JVPM/getUserTaskForIncident/";
export const GETUSERTASKS = "/api/JVPM/getUserTasks?isActive=";
export const GETCLAIM = "/api/JVPM/getClaim?";
export const GETAPPROVE = "/api/JVPM/getApprove?";
export const GETREJECT = "/api/JVPM/getReject?";
export const GETQUEUEDATA = "/api/alerts/getQueueData";
export const POSTRUNAUTOMATASUBMIT = "/api/remediation/bp/automata/AOCC/ACCMVP11DBHOST1";
export const GETINCIDENTAGING = "/api/dashboard/getIncidentAging";
export const GETTERMINATIONRATETREND = "/api/dashboard/getTerminationRateTrend";
export const GETTERMINATIONRATE = "/api/dashboard/getTerminationRate";
export const GETTERMINATIONREASONS = "/api/dashboard/getTerminationReasons";
export const GETAGGREGATIONSTATICS = "/api/dashboard/getAggregationStatics";
export const GETEXCEPTIONCLASSIFICATION = "/api/dashboard/getExceptionClassification";
export const GETHISTORICALACTIVITY = "/api/dashboard/getHistoricalActivity";
export const GETWEEKLYEXECUTIONPERFORMANCE = "/api/dashboard/getWeeklyExecutionPerformance";
export const GETINCIDENTSTATUSVIASEVERITY = "/api/dashboard/getIncidentStatusViaSeverity";
export const GETREOPENCOUNTSLA = "/api/dashboard/getReopenCountSLA";
export const GETINCIDENTBREAKFIX = "/api/dashboard/getIncidentBreakfix";
export const GETINCIDENTPERFORMANCETREND = "/api/dashboard/getIncidentPerformanceTrend";
export const GETSERVICEINDEXFILTERDATAURL = "/api/alerts/getServiceIndexFilterData";
export const CHANGEMANAGEMENT = "/api/incident/changemanagement";
export const GETSLATICKETRESPONSE = "/api/dashboard/getSLATicketResponse";
export const GETSLATICKETRESOLUTION = "/api/dashboard/getSLATicketResolution";
export const GETSLATICKETRESPONSERESOLUTION = "/api/dashboard/getSLATicketResponseResolution";
export const GETSLABYFRANCHISERESPONSERESOLUTION = "/api/dashboard/getSLAByFranchiseResponseResolution";
export const GETSLATREND = "/api/dashboard/getSLATrend";
export const GETQUEUEACCURACYREPORT = "/api/dashboard/getAccuracyReport";
export const GETQUEUEPERFORMANCE = "/api/dashboard/getQueuePerformance";
export const GETQUEUEPERFORMANCEFLTERDATA = "/api/alerts/getQueuePerformanceFilterData";
export const GETINFRAALERTS = "/api/alerts/getInfraAlerts";
export const GETALERTSCLASSIFICATION = "/api/dashboard/getAlertsClassification";
export const GETALERTSGAUGE = "/api/dashboard/getAlertsGauge";
export const GETALERTSKPI = "/api/dashboard/getAlertsKPI";
export const GETALERTSMETRICS = "/api/dashboard/getAlertsMetrics";
export const GETWATSONTOPOLOGY = "/api/alerts/getWatsonTopology";
export const SLA = "/api/incident/sla/";
export const GETSAPFORSMARTOPS = "/api/alerts/getSAPforSmartOPS";
export const GETBOTUTILIZATION = "/api/dashboard/getBotUtilization";
export const GETHOURLYAVGBOTUTILIZATION = "/api/dashboard/getHourlyAvgBotUtilization";
export const GETHOURLYPEAKBOTUTILIZATION = "/api/dashboard/getHourlyPeakBotUtilization";
export const GETDATEWISEAVGBOTUTILIZATION = "/api/dashboard/getDatewiseAvgBotUtilization";
export const GETDATEWISEPEAKBOTUTILIZATION = "/api/dashboard/getDatewisePeakBotUtilization";
export const GETDAYWISEPEAKBOTUTILIZATION = "/api/dashboard/getDaywisePeakBotUtilization";
export const GETDAYWISEAVGBOTUTILIZATION = "/api/dashboard/getDaywiseAvgBotUtilization";
export const GETRESOURCELISTFORUITILIZATION = "/api/dashboard/getResourceListForUtilization";
export const GETBOTONBOARDINGREPORT = "/api/dashboard/getBotOnBoardingReport";
export const GETTOTALALERTSCOUNT = "/api/dashboard/getTotalAlerts";
export const GETDIGITALWORKERTASKDETAILS = "/api/alerts/getDGTaskDetails";
export const GETAUTOMATALIST = "/api/runautomata/run_automata_uniqueautomatanames";
export const GETAUTOMATASTACK = "/api/runautomata/run_automata_getappstack";
export const GETAUTOMATAPARAMS = "/api/runautomata/run_automata_getrunparams";
export const GETEXPECTEDDURATION = "/api/runautomata/run_automata_getexpectedduration";
export const GETAPPSTACK = "/api/runautomata/run_automata_getappstack";
export const GETRESOURCESTATUS = "/api/runautomata/run_automata_getresourcestatus";
export const GETCONFLICTINGSCHEDULE = "/api/runautomata/run_automata_getconflictedschedules";
export const GETSCHEDULEXCEPTIONCLASSIFICATION = "/api/alerts/getSchedulExceptionClassification";
export const GETSchedulingFailuresOccurs = "/api/alerts/getSchedulingFailuresOccurs";
export const GETREMEDIATIONEXCEPTIONSUMMARY= "/api/dashboard/getRemediationExceptionSummary";
export const GETEXCEPTIONANDREMEDIATIONCOUNT= "/api/dashboard/getExceptionAndRemediationCount";
export const GETREMEDIATIONALLACTIVITIES= "/api/dashboard/getRemediationAllActivities";
// export const GETSchedulingFailuresOccurs = "/api/alerts/getSchedulingFailuresOccurs";
export const GETQUEUEMANAGEMENT= "/api/dashboard/getQueueManagement";
export const GETSCHEDULINGFAILURESOCCURS = "/api/alerts/getSchedulingFailuresOccurs";
// export const GETLONGRUNNINGAUTOMATA = "/api/alerts/getLongRunningAutomata";
export const GETTRUSTINDEXSUMMARY = "/api/alerts/getTrustIndexSummary";
export const GETAUTOMATASTARTONTIME = "/api/alerts/getAutomataStartedOnTime";
export const GETAUTOMATARUNONTIME = "/api/alerts/getAutomataRunOnTime";
export const GETBOTPERFORMANCESUMMARY = "/api/dashboard/getrobotperformancesummary";
export const GETROBOTTERMINATIONTREND = "/api/dashboard/getRobotTerminationTrend";
export const GETJUNIPERINCIDENTREPORT = "/api/dashboard/getJuniperIncidentReport";
export const GETJUNIPERTICKETSTREND = "/api/dashboard/getJuniperTicketsTrend";
export const GETAUTOMATIONTRUSTINDEXSUMMARY = "/api/dashboard/getTrustIndexSummary";
export const GETBOTSUMMARYBYGEO = "/api/dashboard/getBotSummaryByGeo";
export const GETBOTSUMMARY = "/api/dashboard/getBotSummary";
export const GETAUTOMATASTARTEDONTIME = "/api/dashboard/getAutomataStartedOnTime";
export const GETAUTOMATARUNSONTIME = "/api/dashboard/getAutomataRunsOnTime";
export const GETTOTALRUNS = "/api/dashboard/getTotalRun";
export const GETTOTALEXECUTIONSBYBOTID = "/api/dashboard/getTotalExecutionsByBotId";
export const GETTOTALEXECUTIONSBYGEOGRAPHY = "/api/dashboard/getTotalExecutionsByGeography";
export const GETCRITICALRESOLUTIONTIME = "/api/dashboard/getCriticalResolutiontime";
export const GETCUSTOMFIELDSFORINCIDENTDETAILS = "/api/alerts/getIncidentDetailsCustomFieldByElastic";
export const GETINCIDENTSTATUSOPTIONS = "/api/incident/getIncidentStatusOptions/";
export const GETINCIDENTURGENCYOPTIONS = "/api/incident/getIncidentUrgencyOptions/";
export const GETINCIDENTIMPACTOPTIONS = "/api/incident/getIncidentImpactOptions/";
export const GETINCIDENTCONTACTTYPEOPTIONS = "/api/incident/getIncidentContactTypeOptions/";
export const GETNORMALRESOLUTIONTIME= "/api/dashboard/getNormalResolutiontime";
export const GETCRITICALRESPONSETIME= "/api/dashboard/getCriticalResponsetime";
export const GETNORMALRESPONSETIME= "/api/dashboard/getNormalResponsetime";
export const GETHOURSSAVED= "/api/dashboard/getHoursSaved";
export const GETONBOARDEDBOTS= "/api/dashboard/getOnboardedBots";
export const AUTOMATARUNSONTIME= "/api/dashboard/getMetricsAutomataRunsOnTime"; 
export const GETRESOURCES= "/api/dashboard/getResources";
export const AUTOMATASTARTSONTIME= "/api/dashboard/getAutomataStartsOnTime";
export const AUTOMATARUNSONTIMELINEGRAPH= "/api/dashboard/getAutomataRunsOnTimeLineGraph";
export const AUTOMATASTARTSONTIMELINEGRAPH= "/api/dashboard/getAutomataStartsOnTimeLineGraph";
export const GETEXCEPTIONCLASSIFICATIONOFINCIDENTS = "/api/dashboard/getExceptionClassificationOfIncidents";
export const GETSCHEDULINGFAILURES = "/api/dashboard/getSchedulingFailures";
export const GETTOPLONGRUNNINGAUTOMATAS = "/api/dashboard/getTopLongRunningAutomatas";
export const GETJUNIPERTICKETSSUMMARY = "/api/dashboard/getJuniperTicketsSummary";
export const SUCCESSRATELINEGRAPH = "/api/dashboard/getSuccessRateLineGraph";
export const GETMETRICSTOTALRUN = "/api/dashboard/getMetricsTotalRun";
export const GETSCHEDULEREFFICIENCYULL = "/api/dashboard/getSchedulerEfficiencyULL";
export const GETSCHEDULERMISSREPORTULL = "/api/dashboard/getSchedulerMissReportULL";
export const GETTOTALRUNULL = "/api/dashboard/getTotalRunULL";
export const GETQUEUETRANSACTIONDETAILS = "/api/dashboard/getQueueTransactionDetails";
export const GETNONQUEUETRANSACTIONDETAILS = "/api/dashboard/getNonQueueTransactionDetails";
export const GETTRANSACTIONTRENDDETAILS = "/api/dashboard/getTransactionTrendDetails";
export const GETPROCESSNUMBER = "/api/dashboard/getProcessNumber";
export const GETCLASSIFICATIONSTATUS ="/api/alerts/classification";
export const GETREPEATEDTERMINATIONBOTS = "/api/dashboard/getRepeatedTerminationBots";
export const GETRECOMMENDEDRESOURCES = "/api/runautomata/recommendvm";
export const GETVM = "/api/runautomata/run_automata_ullvm";
export const RUNAUTOMATA = "/api/runautomata/run_automata_inblueprism";
export const GETBUISNESSOWNERRIGHTS = "/api/database/businessOwnerRights/";
export const GETAUTOMATANAMESLIST = "/api/database/getAutomataNames/";
export const GETRUNSTATUS = "/api/runautomata/run_automata_getRunStatus";
export const GETBOTSUMMARYSHAREDPROD = "/api/dashboard/getBotSummarySharedProd";
export const GETBOTSUMMARYBYGEOSHAREDPROD = "/api/dashboard/getBotSummaryByGeoSharedProd";
export const GETAUTOMATIONTRUSTINDEXSUMMARYSHAREDPROD = "/api/dashboard/getTrustIndexSummarySharedProd";
export const GETINCIDENTSIMILARITY = "/api/incident/similarincidents";
export const GETDAILYTHROUGHPUTFORSINGLEKPI = "/api/alerts/getDailythroughputforSingleKpi"
export const GETDAILYTHROUGHPUTMETRIC = "/api/alerts/getDailythroughputMetric"
export const GETCBMDATAROI = "/api/dashboard/getCBMData";
export const GETCBMSUMMARYDATA = "/api/dashboard/getCBMSummaryData";
export const GETCBMAUTOMATALIST = "/api/dashboard/getCbmAutomataList";
export const GETCBMDATASUCCESSRATE = "/api/dashboard/getCBMDataBySuccessRate";
export const GETCBMDATATERMINATIONRATE = "/api/dashboard/getCBMDataByTerminationRate";
export const GETCBMDATASELFHEALRATE = "/api/dashboard/getCBMDataBySelfHealRate";
export const GETCBMAUTOMATALISTEXCEPTROIKPI = "/api/dashboard/getCbmAutomataListExceptROIKpi";
export const GETCBMDATACAPACITY = "/api/dashboard/getCBMDataByCapMgmt";
export const GETCBMAUTOMATALISTCAPACITYMANAGEMENT= "/api/dashboard/getCbmAutomataListCapMgmtKpi";
export const GETSAPONEALERTS = "/api/alerts/getSapOneAlerts";
export const GETPREDICTIONREPORT= "/api/dashboard/getPredictionReport";
export const GETREMEDIATIONALLACTIVITIESULL = "/api/dashboard/getRemediationAllActivitiesULL";
export const DEPENDENCEYFAILUREIMPACT =  "/api/alerts/getDependencyImpact";
export const GETFIRSTTIMERUN = "/api/dashboard/getFirstTimeRun";
export const RUNAUTOMATATRIGGEREDBY = "/api/runautomata/run_automata_triggered_by";
export const GETUSAGESTATSDETAILS = "/api/dashboard/getUsageStatsDetails";
export const GETSECURITYALERTS = "/api/alerts/getSecurityAlerts";
export const GETSLAINCIDENTS = "/api/incident/sladashboard";
export const GETSLAINCIDENTSTATE = "/api/incident/incidentState";
export const GETSLATOTALINCIDENTS = "/api/incident/totalincidentcount";
export const GETPIT = "/api/alerts/getPit";
export const GETSALESFORCEALERTS = "/api/alerts/getSalesForceAlerts";
export const GETAUTOMATIONINFRAALERTS = "/api/alerts/getInfraAlertsAutomation";
export const GETINCIDENTANALYSIS = "/api/homepage/getIncidentAnalysis";
export const GETINCIDENTSUMMARY = "/api/homepage/getIncidentSummary";
export const GETINCIDENTRESPONSERESOLUTION = "/api/homepage/getIncidentResponseResolution";
export const GETQUEUESTATUS = "/api/queueStatus/getQueueStatus";
export const GETALERTINCIDENTVELOCITYTREND = "/api/dashboard/getAlertIncidentVelocityTrend";
export const GETINCIDENTVELOCITYTREND = "/api/homepage/getIncidentVelocityTrend";
export const GETSUCCESSRATE = "/api/homepage/getSuccessRate";
export const GETRESOURCEISSUESCOUNT = "/api/queueStatus/getResourceIssuesCount";
export const GETAPPLICATIONALERTCOUNT = "/api/dashboard/getApplicationAlertCount";
export const GETINFRAALERTCOUNT = "/api/dashboard/getInfraAlertCount";
export const GETCUSTOMALERTSURL = "/api/alerts/getCustomAlerts";
export const GETINFRAALERTSFILTERDATA = "/api/alerts/getInfraAlertsFilterData";
export const GETINFRAALERTSCLIENTSDATA = "/api/alerts/getInfraAlertsClientsData";
export const GETINSIGHTS = "https://staging.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/api/do/getInsights";
export const UPDATEINSIGHTS = "https://staging.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/api/do/updateInsight";
export const GETRESOURCEISSUESSTATUS = "/api/resourceStatus/getResourceStatus";
export const GETUNIQUECLIENTS = "/api/clients/getUniqueClients";
export const GETINFRAALERTSUMMARY = "/api/dashboard/getInfraAlertSummary";
export const GETALERTVSINCIDENTVELOCITYTREND = "/api/dashboard/getInfraAlertIncidentVelocityTrend";
export const GETINFRAALERTMETRICS = "/api/dashboard/getInfraAlertMetrics";
export const GETCUSTOMAPPLICATIONALERTSURL = "/api/alerts/getCustomApplicationAlerts";
export const GETCUSTOMINFRAALERTSURL = "/api/alerts/getCustomInfraAlerts";
export const GETCUSTOMSECURITYALERTSURL = "/api/alerts/getCustomAlerts";
export const GETACTIONTAKENBYSOC = "/api/incident/getActionbysoc";
export const GETRESOLVEDBYSOC = "/api/incident/getResolvebysoc";
export const GETREASONUPGRADE = "/api/incident/getreasonupgrade";
export const GETINFRAALERTSKPI = "/api/dashboard/getInfraAlertKPI";
export const GETCUSTOMALERTSFILTERDATA = "/api/alerts/getCustomFilterData";
export const GETINFRAVELOCITYANDCOUNT = "/api/dashboard/getInfraVelocityAndCount";
export const GETINCIDENTPRIORITYOPTIONS = "/api/incident/getIncidentPriorityOptions/";
export const GETPRIORITYBASEDONIMPACTANDURGENCY = "/api/incident/getPriorityBasedOnImpactAndUrgency";
export const GETPRIORITYUPGRADEREASON = "/api/incident/getPriorityUpgradeReason";
export const GETPRIORITYDOWNGRADEREASON = "/api/incident/getPriorityDowngradeReason";
export const QUEST = "http://9.46.86.39:8082/component-injection-framework/questConversation?pageId=conversation&realm=local&application="
export const GETSAPMONITORING = "/api/alerts/getSAPMonitoring";
export const GETORDERPROCESSINGTREND = "/api/dashboard/getOrderProcessingTrend";
export const GETBIZOPSCBMTREE = "/api/dashboard/getBizOpsCBMTree";
export const GETORDERAVGPROCESSINGTIME = "/api/dashboard/orderAvgProcessingTime";
export const GETORDERRECEIVEDTILE = "/api/dashboard/orderReceivedTile";
export const GETORDERSTOBEPROCESSEDTILE = "/api/dashboard/ordersToBeProcessedTile";
export const GETDOWNTIME = "/api/dashboard/getDownTime";
export const GETHUMANERRORCOUNT = "/api/dashboard/getHumanErrorCount";
export const GETMACHINEERRORCOUNT = "/api/dashboard/getMachineErrorCount";
export const GETORDERANOMALIESHUMANERROR = "/api/dashboard/getOrderAnomaliesHumanError";
export const GETORDERANOMALIESMACHINEERROR = "/api/dashboard/getOrderAnomaliesMachineError";
export const GETSALESFORCETRENDGRAPH = "/api/dashboard/getSalesForceTrendGraphs";
export const GETSALESFORCETRENDTABLE = "/api/dashboard/getSalesForceTrendTable";
export const GETSALESFORCEALERTSFILTERDATAURL = "/api/alerts/getSalesForceAlertsFilterData";
export const GETBPMNALERTS = "/api/alerts/getBpmnAlerts";
export const GETBPMNFILTERS = "/api/alerts/getBpmnFilters";
export const GETALERTSOURCEFILTERS = "/api/alerts/getAlertSource";
export const GETSYSTEMNAMEFILTERS = "/api/alerts/getSystemName";
export const GETQUEUEITEMDETAILS = "/api/dashboard/getQueueItemDetails";
export const GETINVOICEDETAILS = "/api/dashboard/geInvoiceDetails";
export const GETAVERAGERETRIES = "/api/dashboard/getAverageRetries";
export const GETFILTERSID = "/api/alerts/getFilterSID";
export const GETSOURCETYPE = "/api/alerts/getSourceType";
export const GETBOTONBOARDINGREPORTULL = "/api/dashboard/getBotOnBoardingReportULL";
export const GETSAPSIDBYCLIENTS = "/api/alerts/getSapSidByClients";
export const GETAUTOMATIONGUIDEURL = "https://do-images.s3.eu-gb.cloud-object-storage.appdomain.cloud/Digital%20Operations%20-%20Automation%20Space%20-%20%20User%20Guide%20V2.pdf";
export const GETSAPGUIDEURL = "https://do-images.s3.eu-gb.cloud-object-storage.appdomain.cloud/Digital%20Operations%20-%20SAP%20Workspace%20-%20User%20Guide%20V2.pdf";

































